import { LABELS } from "~/resources/Labels";
import { FormCloudProvisionerTemplateResponse } from "~/models/Commons ";
import { SIMPLDialog } from "~/components/commons/dialog/SimplDialog";

interface Props {
  item: FormCloudProvisionerTemplateResponse;
  onClose: () => void;
}

const valueClass = "py-3 px-2 bg-[#efefef] rounded-md break-words max-w-[600px]";
const labelClass = "font-semibold max-w-[300px]";

export const DetailsViewCloudProvisionerTemplate = ({ item, onClose }: Props) => {
  return (
    <SIMPLDialog onCloseModal={onClose} title={LABELS.DetailView}>
      <div className="w-auto pb-5 flex flex-col gap-y-3">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Name}</div>
            <div className={valueClass}>{item.fileName}</div>
          </div>
        </div>

        <div className="flex flex-row">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.ProviderType}</div>
            <div className={valueClass}>{item.isAzure ? "Azure" : item.isAws ? "AWS" : "—"}</div>
          </div>
        </div>

        {item.isAzure && (
          <>
            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AzureVmSize}</div>
                <div className={valueClass}>{item.azureVmSizes?.join(", ") || "—"}</div>
              </div>
            </div>

            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AzureLocation}</div>
                <div className={valueClass}>{item.azureLocation ?? "—"}</div>
              </div>
            </div>

            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AzureResourceGroup}</div>
                <div className={valueClass}>{item.azureResourceGroup ?? "—"}</div>
              </div>
            </div>

            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AzureAppPorts}</div>
                <div className={valueClass}>
                  {item.azureAppPorts?.length ? item.azureAppPorts.join(", ") : "— (sin NSG)"}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-y-1">
              <div className={labelClass}>{LABELS.SelectOs} / {LABELS.AzureImageUrn}</div>
              {Object.entries(item.osImageUrns ?? {}).length > 0 ? (
                Object.entries(item.osImageUrns).map(([os, urn]) => (
                  <div key={os} className={valueClass}>
                    <span className="font-semibold">{os}</span>: {urn}
                  </div>
                ))
              ) : (
                <div className={valueClass}>—</div>
              )}
            </div>
          </>
        )}

        {item.isAws && (
          <>
            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AwsRegion}</div>
                <div className={valueClass}>{item.awsRegion ?? "—"}</div>
              </div>
            </div>

            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AwsInstanceTypes}</div>
                <div className={valueClass}>{item.awsInstanceTypes?.join(", ") || "—"}</div>
              </div>
            </div>

            <div className="flex flex-row">
              <div className="flex-1">
                <div className={labelClass}>{LABELS.AwsAppPorts}</div>
                <div className={valueClass}>
                  {item.awsAppPorts?.length ? item.awsAppPorts.join(", ") : "— (sin SG)"}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-y-1">
              <div className={labelClass}>{LABELS.SelectOs} / {LABELS.AwsAmiIds}</div>
              {Object.entries(item.awsAmiIds ?? {}).length > 0 ? (
                Object.entries(item.awsAmiIds).map(([os, amiId]) => (
                  <div key={os} className={valueClass}>
                    <span className="font-semibold">{os}</span>: {amiId}
                  </div>
                ))
              ) : (
                <div className={valueClass}>—</div>
              )}
            </div>
          </>
        )}
      </div>
    </SIMPLDialog>
  );
};
